import { render, staticRenderFns } from "./goodsIndex.vue?vue&type=template&id=4a107550&scoped=true&"
import script from "./goodsIndex.vue?vue&type=script&lang=js&"
export * from "./goodsIndex.vue?vue&type=script&lang=js&"
import style0 from "./goodsIndex.vue?vue&type=style&index=0&id=4a107550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a107550",
  null
  
)

export default component.exports